// BHP-1063: tab container on the domain detail page. The DNS tab now runs on
// Backend2.0 (DnsZonePanel); the Databases tab is still the legacy component on
// `/api/v1` and moves with its own story (BHP-1065).
//
// The Bootstrap `nav-tabs` + `data-bs-toggle` markup is gone: tab state is
// plain React, so the panel no longer depends on Bootstrap's JS bundle.
import { useState } from 'react';
import DatabaseOverview from '../Database/DatabaseOverview';
import DnsZonePanel from '../../features/dns/ui/DnsZonePanel';

type Tab = 'dns' | 'databases';

const TABS: Array<{ id: Tab; label: string }> = [
  { id: 'dns', label: 'DNS' },
  { id: 'databases', label: 'Databases' }
];

export default function DomainSettings({
  domainUuid,
  dnsZoneUuid
}: {
  domainUuid: string;
  dnsZoneUuid: string | null;
}): JSX.Element {
  const [active, setActive] = useState<Tab>('dns');

  return (
    <div className="rounded-xl border border-solid border-slate-200 bg-white">
      <div
        role="tablist"
        aria-label="Domain settings"
        className="flex gap-1 border-0 border-b border-solid border-slate-200 px-2 pt-2"
      >
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active === tab.id}
            onClick={() => {
              setActive(tab.id);
            }}
            className={`rounded-t-md border-0 px-4 py-2 text-sm font-medium ${
              active === tab.id
                ? 'bg-white text-teal-700 shadow-[inset_0_-2px_0_0_theme(colors.teal.600)]'
                : 'bg-transparent text-slate-500 hover:text-slate-700'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="p-4">
        {active === 'dns' ? (
          <DnsZonePanel dnsZoneUuid={dnsZoneUuid} />
        ) : (
          <DatabaseOverview domainUuid={domainUuid} />
        )}
      </div>
    </div>
  );
}
